import { decorate, observable } from 'mobx';
import { useLocalStore } from 'mobx-react-lite';
import React, { createContext, FC, ReactElement, useContext } from 'react';
import { ViewState } from '../domain/models/ViewState';
import { Auth } from 'aws-amplify';

export interface User {
  profile?: {
    email?: string;
    firstName?: string;
    lastName?: string;
  };
  accessToken?: string;
}

export class AuthStore {
  viewState: ViewState = ViewState.LOADING;
  user: User = {};

  public async getProfile(): Promise<void> {
    this.viewState = ViewState.OK;
    Auth.currentSession()
      .then(data => {
        const payload = data.getIdToken().payload;
        this.user = {
          profile: {
            email: payload?.email,
            firstName: payload?.name,
            lastName: payload?.middle_name
          },
          accessToken: data.getIdToken().getJwtToken()
        };
        this.viewState = ViewState.OK;
      })
      .catch(error => {
        console.log(error);
        this.viewState = ViewState.ERROR;
      });
  }

  public logout() {
    void Auth.signOut();
    this.user = {};
  }
}

decorate(AuthStore, {
  viewState: observable,
  user: observable
});

interface AuthProviderProps {
  children: ReactElement;
}

export const AuthProvider: FC<AuthProviderProps> = ({
  children
}: AuthProviderProps) => {
  const data = useLocalStore(() => new AuthStore());
  data.getProfile();

  return <AuthContext.Provider value={data}>{children}</AuthContext.Provider>;
};

export const AuthContext = createContext(new AuthStore());
export const useAuth = () => useContext(AuthContext);
